import React, { useEffect, useState } from "react"
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap"
import downArrowIcon from "../../../assets/images/icons/down-arrow-color.svg"

import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js"
import { Bar } from "react-chartjs-2"
import { useLazyGetDashboardPayableAmountChartQuery } from "store/api/reports/reports"
import { formatAmount } from "helpers/common"

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend)

const periods = [
  "This Year",
  "This Half Year",
  "This Quarter",
  "This Month",
  "This Week",
]

const WealthPatnerChart = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const toggle = () => setDropdownOpen((prev) => !prev)
  const [filters, setFilters] = useState({ period: "This Year" })
  const [data, setData] = useState(null)

  const [getResults, { isFetching }] =
    useLazyGetDashboardPayableAmountChartQuery()

  const getList = async () => {
    try {
      const { data } = await getResults({ ...filters }).unwrap()
      setData(data)
    } catch (e) {
      console.error("Error fetching chart data", e)
    }
  }

  useEffect(() => {
    getList()
  }, [filters])

  // ✅ Custom tooltip handler — always top
  const externalTooltipHandler = (context) => {
    const { chart, tooltip } = context
    let tooltipEl = chart.canvas.parentNode.querySelector(
      "div.wealth-patner-chartjs-tooltip"
    )

    if (!tooltipEl) {
      tooltipEl = document.createElement("div")
      tooltipEl.classList.add("wealth-patner-chartjs-tooltip")
      tooltipEl.style.background = "#fff"
      tooltipEl.style.borderRadius = "8px"
      tooltipEl.style.color = "#333"
      tooltipEl.style.padding = "8px 10px"
      tooltipEl.style.position = "absolute"
      tooltipEl.style.pointerEvents = "none"
      tooltipEl.style.transition = "all .15s ease"
      tooltipEl.style.fontSize = "13px"
      tooltipEl.style.zIndex = "999"
      tooltipEl.style.boxShadow = "0 4px 12px rgba(0,0,0,0.1)"
      chart.canvas.parentNode.appendChild(tooltipEl)
    }

    // Hide tooltip when not visible
    if (tooltip.opacity === 0) {
      tooltipEl.style.opacity = 0
      return
    }

    // Update tooltip content
    if (tooltip.dataPoints && tooltip.dataPoints.length) {
      const { raw: value } = tooltip.dataPoints[0]
      tooltipEl.innerHTML = `
        <div>
          <p style="font-size:12px; color:#545454; margin:0;">Commission</p>
          <p style="font-size:14px; color:#030E23; font-weight:500; margin:0;">
            ₹ ${formatAmount(value)}
          </p>
        </div>
      `
    }

    const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas

    const tooltipWidth = tooltipEl.offsetWidth || 100
    const tooltipHeight = tooltipEl.offsetHeight || 40

    const chartWidth = chart.width
    const chartHeight = chart.height

    // Always center horizontally above the bar
    let left = tooltip.caretX - tooltipWidth / 2
    if (left < 0) left = 0
    if (left + tooltipWidth > chartWidth) left = chartWidth - tooltipWidth

    let top = tooltip.caretY - tooltipHeight - 10 // 10px gap above bar
    if (top < 0) top = tooltip.caretY + 10 // flip below if too high

    tooltipEl.style.opacity = 1
    tooltipEl.style.left = positionX + left + "px"
    tooltipEl.style.top = positionY + top + "px"
  }

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: false,
        external: externalTooltipHandler,
      },
    },
    scales: {
      x: {
        grid: { display: false, drawBorder: false },
        ticks: { color: "#555" },
      },
      y: {
        grid: { color: "#f0f0f0", drawBorder: false },
        ticks: { display: false },
      },
    },
  }

  return (
    <>
      <div className="chart-top-section-wrapper wealth-patner">
        <h2>Commission Payable</h2>

        <div className="dropdown-section">
          <Dropdown isOpen={dropdownOpen} toggle={toggle}>
            <DropdownToggle caret size="lg">
              {filters.period} <img src={downArrowIcon} alt="" />
            </DropdownToggle>
            <DropdownMenu style={{ minWidth: "auto" }}>
              {periods.map((item, index) => (
                <DropdownItem
                  key={`periods_${index}`}
                  onClick={() => setFilters({ period: item })}
                >
                  {item}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>

      <div style={{ width: "100%", maxWidth: "100%", position: "relative" }}>
        {data && <Bar data={data} options={options} />}
      </div>
    </>
  )
}

export default WealthPatnerChart
